import React, { Component } from "react";
import { withRouter, Link } from "react-router-dom";
import styles from "./index.module.scss";
import { menuList } from "../../config/menu";

@withRouter
class Index extends Component {
  componentDidMount = () => {
    var cnzz_protocol = (("https:" === document.location.protocol) ? "https://" : "http://");
    document.write(unescape("%3Cspan id='cnzz_stat_icon_1278165970'%3E%3C/span%3E%3Cscript src='" + cnzz_protocol + "s4.cnzz.com/z_stat.php%3Fid%3D1278165970%26show%3Dpic' type='text/javascript'%3E%3C/script%3E"));
  }
  render() {
    const y = (new Date()).getFullYear();
    return (
      <div className={styles.footer_container}>
        <div className={styles.menu_container}>
          <div className={styles.logo_container}>
            <img src="/images/logo.png" alt="雅集logo" />
          </div>
          <div className={styles.menu_lists}>
            {menuList.map(item => {
              return (
                <div key={item.title} className={styles.menu_list}>
                  <span className={styles.title}>{item.title}</span>
                  <ul>
                    {item.children.map(value => {
                      return (
                        <li key={value.key}>
                          <Link to={value.key}>{value.title}</Link>
                        </li>
                      );
                    })}
                  </ul>
                </div>
              );
            })}
          </div>
        </div>
        <div className={styles.icp_container}>
          <div className={styles.icp_text}>© {y} 杭州雅集茶具有限公司<a style={{ padding: '0 10px' }} href="https://beian.miit.gov.cn" target="_black">浙ICP备11065683号-1</a>浙公网安备 33010802004971号</div>
        </div>
      </div>
    );
  }
} 
export default Index;
